import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-box-success',
  templateUrl: './status-box-success.component.html',
  styleUrls: ['./status-box-success.component.scss'],
  standalone: false
})
export class StatusBoxSuccessComponent {
  @Input()
  textContent = '';
}
